import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "py-5",
  id: "track_partner"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 order-lg-first order-md-last" }
const _hoisted_4 = { class: "container pb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, null, -1)
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "col-lg-4 order-lg-last order-md-first" }
const _hoisted_8 = { class: "card shadow-sm border-0 mb-4 mt-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("section", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "text-primary fw-light" }, "Order Related Innovation Proposals for Postpartum Hermorrhage")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollArea = _resolveComponent("ScrollArea")!
  const _component_CardProgress = _resolveComponent("CardProgress")!
  const _component_BaseSearch = _resolveComponent("BaseSearch")!
  const _component_SideFilter = _resolveComponent("SideFilter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _createVNode(_component_ScrollArea, { onProgramId: _ctx.programArea }, null, 8, ["onProgramId"]),
          _hoisted_5
        ]),
        _createElementVNode("section", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackDatas, (data) => {
            return (_openBlock(), _createBlock(_component_CardProgress, {
              key: data.title,
              body: data,
              card: _ctx.cardStyleTrack,
              route: `/partner/home/${data.title}`,
              buttonRoute: `/partner/home/declaration-form`
            }, null, 8, ["body", "card", "route"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_BaseSearch),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_SideFilter, {
            filterAreas: _ctx.sideFilterBtn,
            onFilterTag: _ctx.filterList,
            check: false
          }, null, 8, ["filterAreas", "onFilterTag"])
        ]),
        _hoisted_9
      ])
    ])
  ]))
}